export default __webpack_public_path__ + "static/media/achievement_img.71c1d6a4.png";